export function useMessagingService() {

  function openWhatsAppWithNumber(phoneNumber: string): void {
    const normalized = phoneNumber.replace(/\D/g, '')

    window.open(`https://wa.me/${normalized}`, '_blank')
  }

  function normalizePhoneNumber(value: string): string {
    return value.replace(/[^\d+]/g, '')
  }

  function isValidPhoneNumber(value: string): boolean {
    if ((value?.trim()?.length ?? 0) == 0) {
      return true
    }

    const normalized = normalizePhoneNumber(value)

    return /^\+?[0-9]{6,15}$/.test(normalized.replace(/\s/g, ''))
  }

  /**
   * Very simple DIN 5008 style formatting:
   * +43 664 1234567
   * +49 151 12345678
   */
  function formatDin5008(value: string): string {
    const normalized = normalizePhoneNumber(value)

    if (!normalized.startsWith('+')) {
      return normalized
    }

    const digits = normalized.slice(1)

    if (digits.length < 5) {
      return normalized
    }

    const countryCode = digits.slice(0, 2)
    const rest = digits.slice(2)

    if (rest.length <= 3) {
      return `+${countryCode} ${rest}`
    }

    return `+${countryCode} ${rest.slice(0, 3)} ${rest.slice(3)}`
  }

  return {
    openWhatsAppWithNumber,
    normalizePhoneNumber,
    isValidPhoneNumber,
    formatDin5008
  }
}
